import { initialPagination } from '@components/shared/Table/components/Pagination/types'

import type { GetPurchaseOrdersRequestProps } from '@services/api/ocNf/types'
import type { PurchaseOrdersFormDataProps } from '../context/types'
import { formattedDatePtBrToIso } from '@utils/dates/formattedDatePtBrToIso'

export const parsePurchaseOrdersPayload = (formData: PurchaseOrdersFormDataProps | null) => {
  const payload: GetPurchaseOrdersRequestProps = {
    routeParams: {
      filiCode: formData?.filiCode || '',
      competenceDate: formData?.competenceDate || '',
      supplierCode: formData?.supplierCode || ''
    },
    bodyParams: {
      itemClassification: formData?.itemClassification || '',
      purchaseOrderNumber:
        formData?.purchaseOrder === 'Todos' ? null : formData?.purchaseOrder ? Number(formData?.purchaseOrder) : '',
      expectedDate: formData?.expectedDate ? formattedDatePtBrToIso(formData?.expectedDate) : '',
      purchaseOrderStatus: formData?.status === 'Todos' ? null : formData?.status || '',
      currentPage: formData?.page || initialPagination.PAGE,
      itemsPerPage: formData?.itemsPerPage || initialPagination.ITEMS_PER_PAGE,
      sortBy: formData?.sortType ? formData?.sortBy! : null,
      sortType: formData?.sortType || null
    }
  }

  return payload
}
